import { routeConfig as mfValidationsRouteConfig } from '@klarna/mf-validations/src/routeConfig';
import { isMfValidationOptionValue } from '@/bpc/mf-fields/types/Field.type';
import { getValueByPath, walkInPath } from '@/bpc/mf-fields/types/utils';
export class MfValidationsValidator {
    constructor(mfValidation, currentPayload, pathToField) {
        const pathParts = ((mfValidation === null || mfValidation === void 0 ? void 0 : mfValidation.pathToValidation) || '/').split('/');
        const mfValidationsConfig = Array.isArray(mfValidationsRouteConfig)
            ? mfValidationsRouteConfig.find(r => r.domain === pathParts[0] && r.key === pathParts[1])
            : undefined;
        this.validator = mfValidationsConfig === null || mfValidationsConfig === void 0 ? void 0 : mfValidationsConfig.validate;
        this.preparedOptions =
            typeof mfValidation.options === 'undefined'
                ? undefined
                : Object.keys(mfValidation.options).reduce((acc, key) => {
                    var _a;
                    const option = (_a = mfValidation.options) === null || _a === void 0 ? void 0 : _a[key];
                    if (isMfValidationOptionValue(option)) {
                        return Object.assign(Object.assign({}, acc), { [key]: option.value });
                    }
                    else {
                        // performance: we want to calculate the target path in the constructor once and use it many times in buildOptions() below
                        if (!pathToField) {
                            // TODO MOE-4238 remove this error message, when MOE-4238 is done
                            // eslint-disable-next-line no-console
                            console.error('skipping mfValidation option because pathToField is missing', mfValidation);
                            return Object.assign({}, acc);
                        }
                        else {
                            const path = (option === null || option === void 0 ? void 0 : option.pathToValue.includes('..'))
                                ? walkInPath(pathToField, option.pathToValue)
                                : option === null || option === void 0 ? void 0 : option.pathToValue;
                            return Object.assign(Object.assign({}, acc), { [key]: path ? () => getValueByPath(currentPayload(), path) : undefined });
                        }
                    }
                }, {});
        this.callback = this.callback.bind(this);
        this.errorMessage = this.errorMessage.bind(this);
        this.buildOptions = this.buildOptions.bind(this);
    }
    buildOptions() {
        if (typeof this.preparedOptions === 'undefined') {
            return this.preparedOptions;
        }
        return Object.keys(this.preparedOptions).reduce((acc, key) => {
            var _a;
            const valueOrFunction = (_a = this.preparedOptions) === null || _a === void 0 ? void 0 : _a[key];
            return typeof valueOrFunction === 'function'
                ? Object.assign(Object.assign({}, acc), { [key]: valueOrFunction() }) : Object.assign(Object.assign({}, acc), { [key]: valueOrFunction });
        }, {});
    }
    callback(value) {
        if (!value || !this.validator) {
            return true;
        }
        const result = this.validator(value, this.buildOptions());
        if (typeof result.error !== 'undefined') {
            this.cachedErrorMessage = result.error.message;
            return false;
        }
        return true;
    }
    errorMessage() {
        // performance: error message is cached so that the validation is not evaluated twice when callback() and errorMessage() are called in sequence
        return this.cachedErrorMessage;
    }
}
